import React from 'react'

export default function FeaturedPhotoWrapper({type, photoUrl, onFileLoad}) {
  const fileLoaded = (e) => {
    const files = e.target.files
    if (files && files[0]) onFileLoad(files[0])
  }

  const displayUrl = photoUrl && (typeof photoUrl === 'string' ? photoUrl : photoUrl.url)

  return <div className='row'>
    <div className='col-sm-10 text-center shifted-field'>
      <label className='control-label'>Featured Photo</label>
      { (type != 'new' && displayUrl) &&
          <div className='featured-photo-preview'>
            <img alt='Icon' className='menu_icon img-fluid img-thumbnail' src={displayUrl} />
          </div>
      }
      <input 
        type='file' 
        accept='image/png,image/jpeg' 
        className='form-control'
        onChange={fileLoaded}
      />
    </div>
  </div>
}
